Object.defineProperty(exports, "__esModule", {
  value: true
});
var componentTypes = exports.componentTypes = {
  reactiveList: 'REACTIVELIST',
  dataSearch: 'DATASEARCH',
  categorySearch: 'CATEGORYSEARCH',
  singleList: 'SINGLELIST',
  multiList: 'MULTILIST',
  singleDataList: 'SINGLEDATALIST',
  singleDropdownList: 'SINGLEDROPDOWNLIST',
  multiDataList: 'MULTIDATALIST',
  multiDropdownList: 'MULTIDROPDOWNLIST',
  singleDropdownRange: 'SINGLEDROPDOWNRANGE',
  numberBox: 'NUMBERBOX',
  tagCloud: 'TAGCLOUD',
  toggleButton: 'TOGGLEBUTTON',
  datePicker: 'DATEPICKER',
  dateRange: 'DATERANGE',
  dynamicRangeSlider: 'DYNAMICRANGESLIDER',
  multiDropdownRange: 'MULTIDROPDOWNRANGE',
  singleRange: 'SINGLERANGE',
  multiRange: 'MULTIRANGE',
  rangeSlider: 'RANGESLIDER',
  ratingsFilter: 'RATINGSFILTER',
  rangeInput: 'RANGEINPUT'
};
var validProps = exports.validProps = ['componentType', 'dataField', 'includeFields', 'excludeFields', 'size', 'sortBy', 'sortOptions', 'pagination', 'autoFocus', 'autosuggest', 'debounce', 'defaultValue', 'defaultSuggestions', 'fieldWeights', 'filterLabel', 'fuzziness', 'highlight', 'highlightField', 'nestedField', 'placeholder', 'queryFormat', 'categoryField', 'strictSelection', 'selectAllLabel', 'showCheckbox', 'showFilter', 'showSearch', 'showCount', 'showLoadMore', 'loadMoreLabel', 'showMissing', 'missingLabel', 'data', 'showRadio', 'multiSelect', 'interval', 'showHistogram', 'snap', 'stepValue', 'range', 'showSlider'];